<template>
    <sa-page-layout ref="SaplAreeView" :btnCloseVisible="true" :linkback="linkback" :data="jsonData" :showModalLoading="showModalLoading" :pathResource="pathResource" class="sa-no-space">
        <template slot="table-body">
            <rsa-configurazione-attivita-view-component :showModalLoading="showModalLoading" @errorRestCall="onError" @update="onUpdateJsonData" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></rsa-configurazione-attivita-view-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaConfigurazioneAttivitaViewComponent from "../components/RsaConfigurazioneAttivitaViewComponent.vue";
export default {
    components: { SaPageLayout, RsaConfigurazioneAttivitaViewComponent },
    data() {
        return {
            showModalLoading: false,
            pathResource: "/rsaattivita",
            linkback: "/configurazioni/rsaconfigurazioneattivita",
            jsonData: {},
        };
    },
    mounted() {
        let me = this;
        let tipologia = this.$route.query.tipologia;
        if (tipologia) {
            me.linkback += tipologia.toLowerCase();
        }
    },
    methods: {
        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
        },
        onBeforeLoadData() {},
        onAfterLoadData() {},
        onError(errorData) {
            let me = this;
            me.$refs.SaplAreeView.showModalError(errorData);
        },
    },
};
</script>

<style></style>
